module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner-onlinesupport-d4456ab034d306b1db7b81d9b36c492e.webp";